import type { NodeTypes } from '@xyflow/react';
import { TriggerNode as TriggerNodeComponent } from './TriggerNode';
import { AutomationStepNodeWrapper as AutomationStepNodeWrapperComponent } from './AutomationStepNodeWrapper';
import { SegmentNode as SegmentNodeComponent } from './SegmentNode';
import { BehaviorCaseNode as BehaviorCaseNodeComponent } from './BehaviorCaseNode';
import { ErrorNode as ErrorNodeComponent } from './ErrorNode';
import { PhantomTargetNode as PhantomTargetNodeComponent } from './PhantomTargetNode';

export { TriggerNodeComponent as TriggerNode };
export { AutomationStepNodeWrapperComponent as AutomationStepNodeWrapper };
export { SegmentNodeComponent as SegmentNode };
export { BehaviorCaseNodeComponent as BehaviorCaseNode };
export { ErrorNodeComponent as ErrorNode };
export { PhantomTargetNodeComponent as PhantomTargetNode };

/**
 * Node type registry for React Flow.
 * Maps node type strings to their corresponding React components.
 * The NodeTypes type from @xyflow/react ensures compatibility with React Flow's internal type system.
 */
export const nodeTypes: NodeTypes = {
	trigger: TriggerNodeComponent,
	emailStep: AutomationStepNodeWrapperComponent,
	actionItemStep: AutomationStepNodeWrapperComponent,
	htmlNewsletterStep: AutomationStepNodeWrapperComponent,
	switchStep: AutomationStepNodeWrapperComponent,
	triggerAutomationStep: AutomationStepNodeWrapperComponent,
	textingStep: AutomationStepNodeWrapperComponent,
	addTagStep: AutomationStepNodeWrapperComponent,
	removeTagStep: AutomationStepNodeWrapperComponent,
	handwrittenCardStep: AutomationStepNodeWrapperComponent,
	noActionStep: AutomationStepNodeWrapperComponent,
	opportunityStep: AutomationStepNodeWrapperComponent,
	segment: SegmentNodeComponent,
	behaviorCase: BehaviorCaseNodeComponent,
	error: ErrorNodeComponent,
	phantomTarget: PhantomTargetNodeComponent,
};
